export const GET_SONVI_LIST = "GET_SONVI_LIST";
export const RECEIVED_SONVI_LIST = "RECEIVED_SONVI_LIST";

export const GET_SONVI_ELEMENT = "GET_SONVI_ELEMENT";
export const RECEIVED_SONVI_ELEMENT = "RECEIVE_SONVI_ELEMENT";

export const RECEIVE_CATEGORIES = "RECEIVED_CATEGORIES";

export const UPLOAD_SONVI = "UPLOAD_SONVI";
export const SUCCESS_UPLOAD_SONVI = "SUCCESS_UPLOAD_SONVI";
export const RESET_CURRENT_CATEGORIES = "RESET_CURRENT_CATEGORIES";
export const UPDATE_FILTERED_LIST = "UPDATE_FILTERED_LIST";

export function getSonviList(startDate = "2019-10-1", endDate = "2021-10-31") {
  return { type: GET_SONVI_LIST, payload: { startDate, endDate } };
}
export function getSonviElement(id, history) {
  return { type: GET_SONVI_ELEMENT, payload: { id, history } };
}
export function receiveSonviList(sonviList) {
  return { type: RECEIVED_SONVI_LIST, payload: { sonviList } };
}
export function receiveSonviElement(sonviObject) {
  return { type: RECEIVED_SONVI_ELEMENT, payload: { sonviObject } };
}

export function uploadSonvi(metaData, data, navigate) {
  return {
    type: UPLOAD_SONVI,
    payload: {
      metaData,
      data,
      navigate,
    },
  };
}

// export function updateCurrentCategories(mainCategory, filteredList) {
//     return { type: UPDATE_CURRENT_CATEGORIES };
// }

export function resetCurrentCategories() {
  return { type: RESET_CURRENT_CATEGORIES };
}

export function updateFilteredList(bounds) {
  return { type: UPDATE_FILTERED_LIST, payload: { bounds } };
}
